export default function useFiletype() {
  return (filename: string) => filename.split('.').pop()?.toLocaleUpperCase();
}
